import { render, staticRenderFns } from "./activity-collectCards-get.vue?vue&type=template&id=12f89287&scoped=true&"
import script from "./activity-collectCards-get.vue?vue&type=script&lang=js&"
export * from "./activity-collectCards-get.vue?vue&type=script&lang=js&"
import style0 from "./activity-collectCards-get.vue?vue&type=style&index=0&id=12f89287&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f89287",
  null
  
)

export default component.exports